<template>
    <div class="tw-px-2">
        <edit-special-skills-modal
            v-model="show_skill_dialog"
            :memberId="this.member.id"
            :modelProp="skillSelected"
            :valuelists="valuelists"
            @successful-skill-save="refreshSkillData"
            @successful-skill-delete="refreshSkillData"
        />
        <div class="tw-flex tw-flex-row tw-gap-4">
            <div class="tw-w-1/4">
                <div class="tw-flex tw-flex-wrap">
                    <div class="tw-w-full">
                        <internal-table-section button-text="Add New Skill" @button-clicked="addSkill()"></internal-table-section>
                    </div>
                    <div class="tw-w-full tw-pt-4">
                        <internal-table-section :has-button="false">
                            <div>
                                <v-checkbox label="Sheridan Workshop" v-model="member.sheridan_workshop" dense readonly></v-checkbox>
                                <v-checkbox label="Set Etiquette" v-model="member.set_etiquette" dense readonly></v-checkbox>
                            </div>
                        </internal-table-section>
                    </div>
                </div>
            </div>
            <div class="tw-flex-row tw-flex tw-flex-wrap tw-w-3/4 tw-gap-4">
                <div class="tw-flex" v-for="skill in member.skills" :key="skill.id">
                <internal-table-section class="skillBoxes" button-text="Edit Skill" @button-clicked="editSkill(skill)">
                    <div class="tw-flex tw-flex-col">
                        <h4 class="tw-overflow-ellipsis">{{ skill.skill.group }}</h4>
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <h5 v-on="on" class="tw-overflow-ellipsis tw-whitespace-nowrap tw-overflow-hidden" >{{ skill.skill_name }}</h5>
                            </template>
                            <span>{{ skill.skill_name }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                                <template v-slot:activator="{on}">
                                    <h5 v-on="on">{{ skill.id }}</h5>
                                </template>
                                <span>Skill ID</span>
                            </v-tooltip>
                        <div class="tw-pt-3">
                            <v-textarea
                                label="Notes"
                                outlined
                                readonly
                                auto-grow
                                compact
                                :value="skill.note"
                            >
                            </v-textarea>
                        </div>
                        <div class="tw-flex tw-flex-row tw-text-center tw-gap-2">
                            <div v-show="skill.date_course !== null" class="tw-pt-1 tw-ml-auto">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon v-on="on"
                                            size="x-large"
                                            color="green-darken-2"
                                        >mdi-calendar-today</v-icon>
                                    </template>
                                    <span>Start Date</span>
                                </v-tooltip>
                                {{ skill.date_course }}</div>
                            <v-divider
                                vertical
                                v-show="skill.date_course !== null && skill.date_expire !== null"
                            ></v-divider>
                            <div v-show="skill.date_expire !== null" class="tw-pt-1 tw-mr-auto">
                                <v-tooltip top>
                                    <template v-slot:activator="{on}">
                                        <v-icon
                                            v-on="on"
                                            size="x-large"
                                            color="green-darken-2"
                                        >mdi-calendar-alert</v-icon>
                                    </template>
                                    <span>Expire Date</span>
                                </v-tooltip>
                                {{ skill.date_expire }}
                            </div>
                        </div>
                    </div>
                </internal-table-section>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InternalTableSection from "@/Generic/InternalTableSection";
    import EditSpecialSkillsModal from "@/Pages/InternalPages/Members/Modals/EditSpecialSkillsModal.vue"


    export default {
        name: "MembersShowSpecialSkills",
        components: {
            InternalTableSection,
            EditSpecialSkillsModal,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },

            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                member: this.input,
                saveLoading: false,
                show_skill_dialog: false,
                skillSelected: this.skill,
            }
        },
        methods: {
            editSkill(skill) {
                this.skillSelected = skill
                this.show_skill_dialog = true
            },
            addSkill() {
                this.skillSelected = null
                this.show_skill_dialog = true
            },
            refreshSkillData() {
                this.$inertia.reload({only: ['input']})
            },
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>

<style>
.skillBoxes {
    border-top: 15px #67CEA3 solid !important;
}

</style>
